import navCss from '../../../navigation.module.css'
import { ITask } from '../../../../../types/tasks.types'
import { useRecoilValue } from 'recoil'
import navigationAtom from '../../../navigation.atom'
import useNavigationActions from '../../../useNavigationActions'
import { memo, useMemo } from 'react'
import useFlip from '../../../../../hooks/useFlip'
import useDnD from '../../../../../hooks/useDnD'
import sandboxUtils from '../../../../Sandbox/sandbox.utils'
import sandboxAtom from '../../../../Sandbox/sandbox.atom'
import tasksService from '../../../../../services/tasks/tasks.service'

interface IProps {
  level: ITask
  index: number
}

const LevelTile = (props: IProps) => {
  const sandboxState = useRecoilValue(sandboxAtom)
  const { updatesTasksOrdering } = useNavigationActions()

  const { level } = useRecoilValue(navigationAtom)
  const { toLevel } = useNavigationActions()

  const { element: ref } = useFlip([props.level])

  const starTasks = useMemo(() => {
    return sandboxState.tasks.filter((t) => t.group === props.level.group)
  }, [props.level, sandboxState.tasks])

  const handleSwap = (droppedId: ITask['id']) => {
    const updatedTasks = sandboxUtils.immutableMoveTasks(props.level.id, droppedId, starTasks)

    for (const task of updatedTasks) tasksService.patchTask(task.id, { orderingIndex: task.orderingIndex })
    updatesTasksOrdering(updatedTasks)
  }

  const dnd = useDnD({
    ref: ref,
    id: props.level.id,
    onDrop: handleSwap,
    prefix: '/levels',
    style: {},
  })

  return (
    <div data-active={props.level.id === level} onClick={() => toLevel(props.level.id)} className={navCss.level}>
      <span ref={ref} {...dnd} draggable={true}>
        {props.index + 1}
      </span>
      <div
        className={navCss.fillIndicator}
        data-active={Boolean(
          Boolean(props.level.answerOptions.length) ||
            Boolean(props.level.wordToMatch) ||
            props.level.audio.some((a) => a.rightAnswer) ||
            props.level.images.some((image) => image.rightAnswer) ||
            (props.level.type === 10 && props.level.images.length)
        )}
      />
    </div>
  )
}

export default memo(LevelTile)
